(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-canapes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!button) return;

    var carousel = button.closest('.product-carousel');
    var track = carousel && carousel.querySelector('[data-carousel-track]');
    if (!track) return;

    // Scroll by a full visible "page" (the track's own width), not a
    // single column — this always lands on a clean next/previous group
    // thanks to scroll-snap, with no half-card remainder at the end.
    var scrollAmount = track.clientWidth;

    track.scrollBy({
      left: button.hasAttribute('data-carousel-prev') ? -scrollAmount : scrollAmount,
      behavior: 'smooth'
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var track = event.target.closest('[data-carousel-track]');
    if (!track) return;

    var scrollAmount = track.clientWidth;

    event.preventDefault();
    track.scrollBy({
      left: event.key === 'ArrowLeft' ? -scrollAmount : scrollAmount,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-premium"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalize(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[’'\-]/g, ' ');
    }

    function init(root) {
      var grid = root.querySelector('[data-cc-grid]');
      if (!grid || grid.dataset.ccReady) return;
      grid.dataset.ccReady = '1';

      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-cc-item]'));
      var search = root.querySelector('[data-cc-search]');
      var sort = root.querySelector('[data-cc-sort]');
      var counter = root.querySelector('[data-cc-counter]');
      var noResult = root.querySelector('[data-cc-noresult]');
      var filters = Array.prototype.slice.call(root.querySelectorAll('[data-cc-filter]'));

      function selected(filter) {
        return Array.prototype.slice
          .call(filter.querySelectorAll('input[type="checkbox"]:checked'))
          .map(function (input) { return input.value; });
      }

      function apply() {
        var words = normalize(search ? search.value : '').split(/\s+/).filter(Boolean);
        var active = filters.map(function (filter) {
          var values = selected(filter);
          filter.classList.toggle('is-active', values.length > 0);
          var count = filter.querySelector('[data-cc-count]');
          if (count) count.textContent = values.length ? '(' + values.length + ')' : '';
          return { group: filter.getAttribute('data-cc-filter'), values: values };
        });

        var visible = 0;
        items.forEach(function (item) {
          var text = item._ccText || (item._ccText = normalize(item.getAttribute('data-search')));
          var padded = ' ' + text + ' ';
          var ok = words.every(function (word) {
            // Mots très courts (ex. « s », « l », « xl ») : mot entier uniquement.
            return word.length <= 2 ? padded.indexOf(' ' + word + ' ') !== -1 : text.indexOf(word) !== -1;
          });
          if (ok) {
            ok = active.every(function (f) {
              if (!f.values.length) return true;
              var own = (item.getAttribute('data-' + f.group) || '').split('|');
              return f.values.some(function (v) { return own.indexOf(v) !== -1; });
            });
          }
          item.hidden = !ok;
          if (ok) visible++;
        });

        if (counter) counter.textContent = visible + ' article' + (visible > 1 ? 's' : '');
        if (noResult) noResult.hidden = visible !== 0;
      }

      function applySort() {
        var mode = sort ? sort.value : 'manual';
        var sorted = items.slice().sort(function (a, b) {
          var pa = +a.getAttribute('data-price-value');
          var pb = +b.getAttribute('data-price-value');
          switch (mode) {
            case 'price-asc': return pa - pb;
            case 'price-desc': return pb - pa;
            case 'title-asc': return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'), 'fr');
            case 'newest': return +b.getAttribute('data-created') - +a.getAttribute('data-created');
            default: return +a.getAttribute('data-index') - +b.getAttribute('data-index');
          }
        });
        sorted.forEach(function (item) { grid.appendChild(item); });
      }

      var chipsBox = root.querySelector('[data-cc-chips]');
      function renderChips() {
        if (!chipsBox) return;
        var html = '';
        filters.forEach(function (filter) {
          filter.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
            html += '<button type="button" class="cc-chip" data-chip-group="' + filter.getAttribute('data-cc-filter') + '" data-chip-value="' + input.value + '">' +
              (input.getAttribute('data-cc-label') || input.value) + '<span class="cc-chip__x" aria-hidden="true">×</span></button>';
          });
        });
        if (html) html += '<button type="button" class="cc-chips__clear" data-cc-clear>Tout effacer</button>';
        chipsBox.innerHTML = html;
        chipsBox.hidden = !html;
      }

      if (chipsBox) {
        chipsBox.addEventListener('click', function (event) {
          var chip = event.target.closest('.cc-chip');
          if (chip) {
            var box = root.querySelector('[data-cc-filter="' + chip.getAttribute('data-chip-group') + '"] input[value="' + chip.getAttribute('data-chip-value') + '"]');
            if (box) box.checked = false;
            apply();
            renderChips();
            return;
          }
          if (event.target.closest('[data-cc-clear]')) {
            root.querySelectorAll('[data-cc-filter] input:checked').forEach(function (input) { input.checked = false; });
            apply();
            renderChips();
          }
        });
      }

      root.querySelectorAll('[data-cc-cols]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grid.setAttribute('data-cols', btn.getAttribute('data-cc-cols'));
          root.querySelectorAll('[data-cc-cols]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        });
      });

      if (search) search.addEventListener('input', apply);
      if (sort) sort.addEventListener('change', applySort);
      root.addEventListener('change', function (event) {
        if (event.target.matches('[data-cc-filter] input[type="checkbox"]')) { apply(); renderChips(); }
      });

      filters.forEach(function (filter) {
        filter.addEventListener('toggle', function () {
          if (!filter.open) return;
          filters.forEach(function (other) { if (other !== filter) other.open = false; });
        });
      });

      document.addEventListener('click', function (event) {
        filters.forEach(function (filter) {
          if (filter.open && !filter.contains(event.target)) filter.open = false;
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') filters.forEach(function (filter) { filter.open = false; });
      });

      var reset = root.querySelector('[data-cc-reset]');
      if (reset) {
        reset.addEventListener('click', function () {
          if (search) search.value = '';
          root.querySelectorAll('[data-cc-filter] input:checked').forEach(function (input) { input.checked = false; });
          apply();
          renderChips();
        });
      }
    }

    function boot() {
      document.querySelectorAll('.cc-collection').forEach(init);
    }

    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.gReady) return;
      root.dataset.gReady = '1';
      var track = root.querySelector('[data-g-track]');
      if (!track) return;
      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || root.getAttribute('data-autoplay') !== 'true') {
        root.classList.add('is-static');
        return;
      }

      var speed = parseFloat(root.getAttribute('data-speed')) || 35; // px par seconde
      var loop = 0;      // largeur d'un jeu complet d'avis
      var x = 0;
      var last = 0;
      var paused = false;
      var visible = true;

      function measure() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var lastItem = items[items.length - 1];
        loop = lastItem.offsetLeft + lastItem.offsetWidth + gap - items[0].offsetLeft;
      }

      // Copies des cartes (masquées aux lecteurs d'écran) : toujours au moins
      // un jeu complet en plus, et assez pour couvrir l'écran, sinon trou.
      function fill() {
        var guard = 0;
        while ((track.children.length < items.length * 2 || track.scrollWidth < loop + root.clientWidth + 40) && guard < 8) {
          items.forEach(function (it) {
            var c = it.cloneNode(true);
            c.setAttribute('aria-hidden', 'true');
            c.removeAttribute('data-shopify-editor-block');
            track.appendChild(c);
          });
          guard++;
        }
      }

      measure();
      fill();
      x = 0;

      function frame(t) {
        if (!last) last = t;
        var dt = Math.min(64, t - last);
        last = t;
        if (!paused && visible && loop > 0) {
          x -= speed * dt / 1000; // vers la gauche
          if (x <= -loop) x += loop;
          track.style.transform = 'translate3d(' + x + 'px,0,0)';
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);

      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
        root.addEventListener(ev, function () { paused = true; }, { passive: true });
      });
      ['mouseleave', 'focusout'].forEach(function (ev) {
        root.addEventListener(ev, function () { paused = false; });
      });
      root.addEventListener('touchend', function () {
        setTimeout(function () { paused = false; }, 3000);
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
        }).observe(root);
      }
      window.addEventListener('resize', function () { measure(); fill(); });
    }

    function boot() {
      document.querySelectorAll('[data-g-reviews]').forEach(init);
    }

    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function initProductMain(root) {
      // The variant-data script, the zoom dialog and the mobile bar are
      // deliberately rendered as siblings of .product-main (not inside it),
      // so they must be looked up from `document`, not from `root` —  a
      // root-scoped query here previously returned null on every load and
      // silently skipped every listener below (gallery, quantity, variant
      // switching, zoom, mobile bar). Keep this as document-scoped.
      var dataEl = document.querySelector('[data-variant-data]');
      if (!dataEl) return;

      var variantData;
      try {
        variantData = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var variantIdInput = root.querySelector('[data-product-variant-id]');
      var priceEl = root.querySelector('[data-product-price]');
      var comparePriceEl = root.querySelector('[data-product-compare-price]');
      var badgeEl = root.querySelector('[data-product-badge]');
      var addToCartBtn = root.querySelector('[data-add-to-cart]');
      var addToCartLabel = root.querySelector('[data-add-to-cart-label]');
      var availabilityText = root.querySelector('[data-availability-text]');
      var availabilityEl = root.querySelector('[data-product-availability]');
      var optionGroups = root.querySelectorAll('[data-option-index]');
      var mobileBar = document.querySelector('[data-mobile-bar]');
      var mobileBarPrice = mobileBar && mobileBar.querySelector('[data-mobile-bar-price]');
      var mobileBarCta = mobileBar && mobileBar.querySelector('[data-mobile-bar-cta]');

      function getSelectedOptions() {
        var values = [];
        optionGroups.forEach(function (group) {
          var checked = group.querySelector('input[data-option-input]:checked');
          values.push(checked ? checked.value : null);
        });
        return values;
      }

      function findVariantId(selected) {
        for (var id in variantData) {
          if (!Object.prototype.hasOwnProperty.call(variantData, id)) continue;
          var options = variantData[id].options || [];
          if (options.length !== selected.length) continue;
          var match = true;
          for (var i = 0; i < options.length; i++) {
            if (options[i] !== selected[i]) {
              match = false;
              break;
            }
          }
          if (match) return id;
        }
        return null;
      }

      function updateUI(variantId) {
        var data = variantData[variantId];
        if (!data) return;

        if (variantIdInput) variantIdInput.value = variantId;
        if (priceEl) priceEl.textContent = data.price;
        if (mobileBarPrice) mobileBarPrice.textContent = data.price;

        if (comparePriceEl) {
          if (data.comparePrice) {
            comparePriceEl.textContent = data.comparePrice;
            comparePriceEl.removeAttribute('hidden');
          } else {
            comparePriceEl.setAttribute('hidden', '');
          }
        }

        if (badgeEl) {
          if (data.badge) {
            badgeEl.textContent = '-' + data.badge + '%';
            badgeEl.removeAttribute('hidden');
          } else {
            badgeEl.setAttribute('hidden', '');
          }
        }

        if (addToCartBtn) {
          addToCartBtn.disabled = !data.available;
          if (addToCartLabel) {
            addToCartLabel.textContent = data.available
              ? addToCartBtn.getAttribute('data-label-available')
              : addToCartBtn.getAttribute('data-label-unavailable');
          }
        }

        if (mobileBarCta) {
          mobileBarCta.disabled = !data.available;
          mobileBarCta.textContent = data.available ? 'Ajouter' : 'Indisponible';
        }

        if (availabilityText && availabilityEl) {
          if (!data.available) {
            availabilityText.textContent = availabilityEl.getAttribute('data-label-unavailable');
          } else if (data.inventoryQuantity > 0) {
            availabilityText.textContent = availabilityEl.getAttribute('data-label-in-stock');
          } else {
            availabilityText.textContent = availabilityEl.getAttribute('data-label-backorder');
          }
        }

        // NOTE: deliberately no gallery/image update here. Selecting a
        // color or an angle must NEVER change the displayed media — only
        // a manual thumbnail click (or the lightbox) may do that. This is
        // an explicit, repeated requirement, not an oversight.
      }

      var configSummaryEl = root.querySelector('[data-config-summary]');
      function sentenceCase(value) {
        // Display-only normalization ("Gris anthracite", never "Gris
        // Anthracite" or "GRIS ANTHRACITE") — mirrors the `capitalize`
        // Liquid filter used for the server-rendered version of this
        // same line, so there is no flash of different casing on load.
        if (!value) return value;
        var lower = value.toLowerCase();
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      }
      function updateConfigSummary() {
        if (!configSummaryEl) return;
        var parts = [];
        optionGroups.forEach(function (group) {
          // Hidden groups are the color option kept alive for cart logic
          // only (see product-main__option--hidden above) — never surface
          // its value in this human-readable summary either.
          if (group.hidden) return;
          var checked = group.querySelector('input[data-option-input]:checked');
          if (checked) parts.push(sentenceCase(checked.value));
        });
        configSummaryEl.textContent = parts.length ? 'Votre configuration : ' + parts.join(' · ') : '';
      }

      optionGroups.forEach(function (group) {
        group.addEventListener('change', function () {
          var checked = group.querySelector('input[data-option-input]:checked');
          var valueLabel = group.querySelector('[data-selected-value]');
          if (checked && valueLabel) valueLabel.textContent = checked.value;

          updateConfigSummary();

          var variantId = findVariantId(getSelectedOptions());
          if (variantId) updateUI(variantId);
        });
      });

      // Gallery
      var thumbs = root.querySelectorAll('[data-gallery-thumb]');
      var slides = root.querySelectorAll('[data-gallery-slide]');
      var counter = root.querySelector('[data-gallery-counter-current]');
      var thumbsTrack = root.querySelector('[data-gallery-thumbs]');
      var prevBtn = root.querySelector('[data-thumbs-prev]');
      var nextBtn = root.querySelector('[data-thumbs-next]');
      // Set below once the lightbox is initialized — activateSlide is the
      // single source of truth for "which media is current", so every
      // consumer (thumbnails, counter, lightbox) is driven from here
      // instead of keeping its own separately-updated copy of the state.
      var lightboxSync = null;

      function activateSlide(index) {
        thumbs.forEach(function (thumb) {
          var active = thumb.getAttribute('data-index') === String(index);
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-index') === String(index));
        });
        if (counter) counter.textContent = String(Number(index) + 1);
        if (lightboxSync) lightboxSync(index);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateSlide(thumb.getAttribute('data-index'));
        });
      });

      // Carousel arrows on the main photo — same activateSlide() as the
      // thumbnails (wraps around), and keep the active thumbnail visible
      // in its rail without scrolling the page itself.
      function activeSlideIndex() {
        var active = root.querySelector('.product-main__slide.is-active');
        return active ? Number(active.getAttribute('data-index')) : 0;
      }

      function revealActiveThumb(index) {
        if (!thumbsTrack) return;
        var thumb = thumbsTrack.querySelector('[data-gallery-thumb][data-index="' + index + '"]');
        if (!thumb) return;
        var trackRect = thumbsTrack.getBoundingClientRect();
        var thumbRect = thumb.getBoundingClientRect();
        if (thumbRect.left < trackRect.left) {
          thumbsTrack.scrollBy({ left: thumbRect.left - trackRect.left - 8, behavior: 'smooth' });
        } else if (thumbRect.right > trackRect.right) {
          thumbsTrack.scrollBy({ left: thumbRect.right - trackRect.right + 8, behavior: 'smooth' });
        }
      }

      function stepSlide(delta) {
        var total = slides.length;
        if (!total) return;
        var next = (activeSlideIndex() + delta + total) % total;
        activateSlide(next);
        revealActiveThumb(next);
      }

      var galleryPrev = root.querySelector('[data-gallery-prev]');
      var galleryNext = root.querySelector('[data-gallery-next]');
      if (galleryPrev) galleryPrev.addEventListener('click', function () { stepSlide(-1); });
      if (galleryNext) galleryNext.addEventListener('click', function () { stepSlide(1); });

      function updateThumbNav() {
        if (!thumbsTrack || !prevBtn || !nextBtn) return;
        var scrollable = thumbsTrack.scrollWidth > thumbsTrack.clientWidth + 2;
        if (!scrollable) {
          prevBtn.hidden = true;
          nextBtn.hidden = true;
          return;
        }
        prevBtn.hidden = thumbsTrack.scrollLeft <= 2;
        nextBtn.hidden = thumbsTrack.scrollLeft + thumbsTrack.clientWidth >= thumbsTrack.scrollWidth - 2;
      }

      if (thumbsTrack && prevBtn && nextBtn) {
        var scrollStep = function () {
          return Math.max(thumbsTrack.clientWidth * 0.7, 150);
        };
        prevBtn.addEventListener('click', function () {
          thumbsTrack.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', function () {
          thumbsTrack.scrollBy({ left: scrollStep(), behavior: 'smooth' });
        });
        thumbsTrack.addEventListener('scroll', updateThumbNav, { passive: true });
        window.addEventListener('resize', updateThumbNav);
        updateThumbNav();
      }

      // Quantity — same increment/decrement/min-1 logic as before, plus a
      // brief discreet "pulse" on the value when it changes via the
      // buttons. Purely cosmetic: it never touches the value itself, so
      // the correct quantity still reaches the cart on submit.
      var qtyInput = root.querySelector('[data-quantity-input]');
      var qtyMinus = root.querySelector('[data-quantity-minus]');
      var qtyPlus = root.querySelector('[data-quantity-plus]');
      var qtyReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function pulseQtyInput() {
        if (qtyReducedMotion || !qtyInput) return;
        qtyInput.classList.remove('is-pulsing');
        // Force a reflow so re-triggering the class on rapid clicks restarts
        // the transition instead of being a no-op.
        void qtyInput.offsetWidth;
        qtyInput.classList.add('is-pulsing');
        window.setTimeout(function () {
          qtyInput.classList.remove('is-pulsing');
        }, 180);
      }

      if (qtyMinus && qtyInput) {
        qtyMinus.addEventListener('click', function () {
          var value = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = Math.max(1, value - 1);
          pulseQtyInput();
        });
      }

      if (qtyPlus && qtyInput) {
        qtyPlus.addEventListener('click', function () {
          var value = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = value + 1;
          pulseQtyInput();
        });
      }

      // Lightbox — ONE system: the zoom button and a click on the main
      // image both open it (data-gallery-open on both), always on
      // whichever slide is currently active. It only ever mirrors the
      // gallery's own state (activateSlide is the single source of
      // truth for "which media is current" — see below), so it can
      // never show a different image than the page itself.
      var lightbox = document.querySelector('[data-gallery-lightbox]');
      var lastFocusedTrigger = null;

      if (lightbox) {
        var lightboxImage = lightbox.querySelector('[data-gallery-lightbox-image]');
        var lightboxCounterCurrent = lightbox.querySelector('[data-gallery-lightbox-counter-current]');
        var lightboxThumbs = lightbox.querySelectorAll('[data-gallery-lightbox-thumb]');
        var lightboxPrev = lightbox.querySelector('[data-gallery-lightbox-prev]');
        var lightboxNext = lightbox.querySelector('[data-gallery-lightbox-next]');
        var lightboxClose = lightbox.querySelector('[data-gallery-lightbox-close]');
        var openTriggers = root.querySelectorAll('[data-gallery-open]');

        function currentIndex() {
          var active = root.querySelector('.product-main__slide.is-active');
          return active ? Number(active.getAttribute('data-index')) : 0;
        }

        function syncLightbox(index) {
          var slide = root.querySelector('.product-main__slide[data-index="' + index + '"]');
          var img = slide && slide.querySelector('img');
          if (img && lightboxImage) {
            lightboxImage.src = img.currentSrc || img.src;
            lightboxImage.alt = img.alt || '';
          }
          if (lightboxCounterCurrent) lightboxCounterCurrent.textContent = String(index + 1);
          lightboxThumbs.forEach(function (thumb) {
            thumb.classList.toggle('is-active', thumb.getAttribute('data-index') === String(index));
          });
        }

        lightboxSync = function (index) {
          if (lightbox.open) syncLightbox(index);
        };

        function openLightbox() {
          lastFocusedTrigger = document.activeElement;
          syncLightbox(currentIndex());
          if (typeof lightbox.showModal === 'function') lightbox.showModal();
          if (lightboxClose) lightboxClose.focus();
        }

        function closeLightbox() {
          if (lightbox.open) lightbox.close();
        }

        function goTo(delta) {
          var total = slides.length;
          if (!total) return;
          var next = (currentIndex() + delta + total) % total;
          activateSlide(next);
        }

        openTriggers.forEach(function (trigger) {
          trigger.addEventListener('click', function (event) {
            event.preventDefault();
            openLightbox();
          });
        });

        if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
        if (lightboxPrev) lightboxPrev.addEventListener('click', function () { goTo(-1); });
        if (lightboxNext) lightboxNext.addEventListener('click', function () { goTo(1); });

        lightboxThumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            activateSlide(Number(thumb.getAttribute('data-index')));
          });
        });

        // Click on the dialog itself (its backdrop area, not the image or
        // any control) closes it — same behaviour as clicking outside.
        lightbox.addEventListener('click', function (event) {
          if (event.target === lightbox || event.target.classList.contains('product-main__lightbox-stage')) {
            closeLightbox();
          }
        });

        // Native <dialog> already closes on Escape (fires 'cancel'); just
        // restore focus to whatever opened it, and add the left/right
        // arrow-key navigation the browser doesn't provide for free.
        lightbox.addEventListener('cancel', function () {
          // let the native close proceed; focus restore happens in 'close'
        });

        lightbox.addEventListener('close', function () {
          if (lastFocusedTrigger && typeof lastFocusedTrigger.focus === 'function') {
            lastFocusedTrigger.focus();
          }
        });

        lightbox.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') goTo(-1);
          if (event.key === 'ArrowRight') goTo(1);
        });

        // Touch swipe (native JS, no library) — a clear enough horizontal
        // gesture with limited vertical drift moves to the next/previous
        // image; the on-screen arrows remain as a complementary option.
        var touchStartX = null;
        var touchStartY = null;
        var stage = lightbox.querySelector('.product-main__lightbox-stage');
        if (stage) {
          stage.addEventListener(
            'touchstart',
            function (event) {
              if (!event.touches.length) return;
              touchStartX = event.touches[0].clientX;
              touchStartY = event.touches[0].clientY;
            },
            { passive: true }
          );
          stage.addEventListener(
            'touchend',
            function (event) {
              if (touchStartX === null) return;
              var touch = event.changedTouches[0];
              var deltaX = touch.clientX - touchStartX;
              var deltaY = touch.clientY - touchStartY;
              touchStartX = null;
              touchStartY = null;
              if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY) * 1.5) {
                goTo(deltaX < 0 ? 1 : -1);
              }
            },
            { passive: true }
          );
        }

      }

      // Mobile sticky bar — shows once the real CTA is out of view.
      var realCta = root.querySelector('[data-add-to-cart]');
      if (mobileBar && realCta && typeof IntersectionObserver !== 'undefined') {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              mobileBar.hidden = entry.isIntersecting;
            });
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        observer.observe(realCta);
      }

      if (mobileBarCta) {
        mobileBarCta.addEventListener('click', function () {
          var form = document.getElementById('product-form');
          if (!form) return;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            var submitBtn = form.querySelector('[data-add-to-cart]');
            if (submitBtn) submitBtn.click();
          }
        });
      }

      // FAQ accordion — single panel open at a time, real buttons, real
      // aria-expanded/aria-controls, no card, no external library. The
      // panel is animated (grid-template-rows 0fr → 1fr, see CSS); `hidden`
      // is still used to fully remove closed panels from the a11y tree,
      // just applied/removed around the transition instead of instantly.
      var faqReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var faqCloseTimers = new WeakMap();

      function closeFaqPanel(panel) {
        if (!panel) return;
        var pending = faqCloseTimers.get(panel);
        if (pending) window.clearTimeout(pending);
        panel.classList.remove('is-open');
        if (faqReducedMotion) {
          panel.hidden = true;
        } else {
          var timer = window.setTimeout(function () {
            panel.hidden = true;
          }, 350);
          faqCloseTimers.set(panel, timer);
        }
      }

      function openFaqPanel(panel) {
        if (!panel) return;
        var pending = faqCloseTimers.get(panel);
        if (pending) window.clearTimeout(pending);
        panel.hidden = false;
        // Force layout so the transition starts from the collapsed state
        // instead of jumping straight to open when `hidden` is removed.
        void panel.offsetHeight;
        panel.classList.add('is-open');
      }

      var faqTriggers = root.querySelectorAll('[data-faq-trigger]');
      faqTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';

          faqTriggers.forEach(function (otherTrigger) {
            if (otherTrigger === trigger) return;
            var otherPanel = document.getElementById(otherTrigger.getAttribute('aria-controls'));
            otherTrigger.setAttribute('aria-expanded', 'false');
            closeFaqPanel(otherPanel);
          });

          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          if (isOpen) {
            trigger.setAttribute('aria-expanded', 'false');
            closeFaqPanel(panel);
          } else {
            trigger.setAttribute('aria-expanded', 'true');
            openFaqPanel(panel);
          }
        });
      });

      // Estimated delivery window — only rendered when the merchant set
      // both "délai min/max (jours ouvrés)" in the section settings.
      // Computed from today's date in the visitor's browser, weekends
      // skipped, e.g. "Livraison estimée entre le 12 et le 28 mars".
      var deliveryEl = root.querySelector('[data-delivery-estimate]');
      if (deliveryEl) {
        var minDays = parseInt(deliveryEl.getAttribute('data-min-days'), 10);
        var maxDays = parseInt(deliveryEl.getAttribute('data-max-days'), 10);
        if (!isNaN(minDays) && !isNaN(maxDays) && minDays >= 0 && maxDays >= minDays) {
          var months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
          var addBusinessDays = function (start, days) {
            var date = new Date(start.getTime());
            var added = 0;
            while (added < days) {
              date.setDate(date.getDate() + 1);
              var day = date.getDay();
              if (day !== 0 && day !== 6) added++;
            }
            return date;
          };
          var today = new Date();
          var from = addBusinessDays(today, minDays);
          var to = addBusinessDays(today, maxDays);
          var dayLabel = function (date) {
            return date.getDate() === 1 ? '1er' : String(date.getDate());
          };
          var text;
          if (from.getTime() === to.getTime()) {
            text = 'Livraison estimée le ' + dayLabel(to) + ' ' + months[to.getMonth()];
          } else if (from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()) {
            text = 'Livraison estimée entre le ' + dayLabel(from) + ' et le ' + dayLabel(to) + ' ' + months[to.getMonth()];
          } else {
            text = 'Livraison estimée entre le ' + dayLabel(from) + ' ' + months[from.getMonth()] + ' et le ' + dayLabel(to) + ' ' + months[to.getMonth()];
          }
          deliveryEl.textContent = text;
        }
      }

      // Favorite (heart) — remembered in this browser only (localStorage).
      // Purely additive: never touches the cart form, and every storage
      // call is guarded so a blocked/private storage never breaks the page.
      var favoriteBtn = root.querySelector('[data-favorite]');
      if (favoriteBtn) {
        var favoriteKey = 'centralcanap:favorites';
        var favoriteId = favoriteBtn.getAttribute('data-product-id');
        var readFavorites = function () {
          try {
            var raw = window.localStorage.getItem(favoriteKey);
            var list = raw ? JSON.parse(raw) : [];
            return Array.isArray(list) ? list : [];
          } catch (e) {
            return [];
          }
        };
        var writeFavorites = function (list) {
          try {
            window.localStorage.setItem(favoriteKey, JSON.stringify(list));
          } catch (e) {}
        };
        var renderFavorite = function (isOn) {
          favoriteBtn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
          favoriteBtn.setAttribute('aria-label', favoriteBtn.getAttribute(isOn ? 'data-label-on' : 'data-label-off'));
        };
        renderFavorite(readFavorites().indexOf(favoriteId) !== -1);
        favoriteBtn.addEventListener('click', function () {
          var list = readFavorites();
          var position = list.indexOf(favoriteId);
          var isOn = position === -1;
          if (isOn) {
            list.push(favoriteId);
          } else {
            list.splice(position, 1);
          }
          writeFavorites(list);
          renderFavorite(isOn);
          if (typeof window.CentralCanapeToast === 'function') {
            window.CentralCanapeToast(isOn ? 'Ajouté à vos favoris' : 'Retiré de vos favoris');
          }
        });
      }
    }

    ready(function () {
      document.querySelectorAll('.product-main').forEach(initProductMain);
    });

    // Shopify theme editor: a section is fully re-rendered (fresh DOM) when
    // its settings change, so listeners bound to the old nodes are simply
    // discarded with them — re-run init against the new markup.
    document.addEventListener('shopify:section:load', function (event) {
      var main = event.target.querySelector('.product-main');
      if (main) initProductMain(main);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      document.querySelectorAll('[data-product-recommendations]').forEach(function (el) {
        var url = el.getAttribute('data-url');
        if (!url) return;

        fetch(url)
          .then(function (response) {
            return response.ok ? response.text() : null;
          })
          .then(function (html) {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newEl = doc.querySelector('[data-product-recommendations]');
            if (newEl && newEl.innerHTML.trim() !== '') {
              el.innerHTML = newEl.innerHTML;
              // The swapped-in markup carries its own [data-reveal] wrapper,
              // but it arrived after the page's own reveal observer already
              // ran its one-time querySelectorAll — show it directly rather
              // than leaving it permanently invisible waiting for an
              // observer that will never see it.
              var revealed = el.querySelector('[data-reveal]');
              if (revealed) {
                revealed.classList.remove('reveal-init');
                revealed.classList.add('reveal-visible');
              }
            }
          })
          .catch(function () {});
      });
    });
  })();

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rec-carousel-prev], [data-rec-carousel-next]');
    if (!button) return;

    var carousel = button.closest('.product-recommendations');
    var track = carousel && carousel.querySelector('[data-rec-carousel-track]');
    if (!track) return;

    // Scroll by a full visible "page" of cards, not a single card — always
    // lands on a clean next/previous group thanks to scroll-snap.
    var scrollAmount = track.clientWidth;

    track.scrollBy({
      left: button.hasAttribute('data-rec-carousel-prev') ? -scrollAmount : scrollAmount,
      behavior: 'smooth'
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var track = event.target.closest('[data-rec-carousel-track]');
    if (!track) return;

    var scrollAmount = track.clientWidth;

    event.preventDefault();
    track.scrollBy({
      left: event.key === 'ArrowLeft' ? -scrollAmount : scrollAmount,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();
})();
